import { ViewLodgingOptionState, ViewLodgingOptionActionTypes, VIEW_LODGING_OPTION_DATA_REQUEST, VIEW_LODGING_OPTION_DATA_SUCCESS, VIEW_LODGING_OPTION_DATA_FAILURE } from "store/reducers/lodgingOption/view/types";

const defaultState: ViewLodgingOptionState = {
  isLoading: false,
  errorMessage: ""
};

export default function viewLodgingOption(state = defaultState, action: ViewLodgingOptionActionTypes): ViewLodgingOptionState {
  switch (action.type) {
    case VIEW_LODGING_OPTION_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case VIEW_LODGING_OPTION_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case VIEW_LODGING_OPTION_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};